/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Name_HintInputs */

const en_admin_discounts_name_hint = /** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only visible to admins`)
};

const de_admin_discounts_name_hint = /** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur für Admins sichtbar`)
};

const es_admin_discounts_name_hint = /** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible solo para administradores`)
};

const fr_admin_discounts_name_hint = /** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible uniquement par les administrateurs`)
};

/** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */
const it_admin_discounts_name_hint = en_admin_discounts_name_hint;

/** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */
const pt_br2_admin_discounts_name_hint = en_admin_discounts_name_hint;

/** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */
const pl_admin_discounts_name_hint = en_admin_discounts_name_hint;

/** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */
const hu_admin_discounts_name_hint = en_admin_discounts_name_hint;

/** @type {(inputs: Admin_Discounts_Name_HintInputs) => LocalizedString} */
const ro_admin_discounts_name_hint = en_admin_discounts_name_hint;

/**
* | output |
* | --- |
* | "Only visible to admins" |
*
* @param {Admin_Discounts_Name_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_name_hint = /** @type {((inputs?: Admin_Discounts_Name_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Name_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_name_hint(inputs)
	if (locale === "de") return de_admin_discounts_name_hint(inputs)
	if (locale === "es") return es_admin_discounts_name_hint(inputs)
	if (locale === "fr") return fr_admin_discounts_name_hint(inputs)
	if (locale === "it") return it_admin_discounts_name_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_name_hint(inputs)
	if (locale === "pl") return pl_admin_discounts_name_hint(inputs)
	if (locale === "hu") return hu_admin_discounts_name_hint(inputs)
	return ro_admin_discounts_name_hint(inputs)
});
export { admin_discounts_name_hint as "admin.discounts.name_hint" }